export default "__VITE_ASSET__0205c065__"